import { render, staticRenderFns } from "./TaxAdmin.vue?vue&type=template&id=30cc22ea&scoped=true&"
import script from "./TaxAdmin.vue?vue&type=script&lang=js&"
export * from "./TaxAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc22ea",
  null
  
)

export default component.exports